import type { RadioGroupProps } from '@lokalise/louis';
import { RadioGroup } from '@lokalise/louis';
import { useField } from 'formik';

interface RadioGroupFieldProps extends Omit<RadioGroupProps, 'error'> {
    name: string;
}

const RadioGroupField = ({ name, ...props }: RadioGroupFieldProps) => {
    const [field, { error }] = useField({ name, type: 'checkbox', value: props.value });

    return <RadioGroup {...field} error={error} {...props} />;
};

export default RadioGroupField;
